export const DEFAULT_PLACEHOLDER = 'Search...'
export const DEFAULT_DROPDOWN_HEIGHT = 220
